// extracted by mini-css-extract-plugin
export default {"container":"ContentTitle_container__TKpK-","title":"ContentTitle_title__rF8jv"};